import { Box } from "@mui/material";
import Header from "components/header";
import { InsightsPanel } from "./InsightsPanel";
import { INSIGHTS_FONT } from "./tokens";

/**
 * O Insights em tela cheia, sem cliente definido pela rota.
 *
 * Não há mais entrada de menu para cá — o caminho normal é o botão flutuante
 * dentro de um cliente, que abre o mesmo painel já no CNPJ daquela tela. Esta
 * rota continua de pé para link direto e para quem quer o painel sem recorte.
 */
export function InsightsPage() {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        overflow: "hidden",
        fontFamily: INSIGHTS_FONT,
      }}
    >
      <Header />
      <InsightsPanel />
    </Box>
  );
}
